module.exports = __webpack_public_path__ + "static/opportunity-f8014ea1b87c536711547aaf676415f7.jpeg";